import campaignsConstants from '../constants/campaigns-constants';

export const validate = formValues => {
  const errors = {};

  if (!formValues[campaignsConstants.fields.name]) {
    errors[campaignsConstants.fields.name] = 'CAMPAIGNS.LINK_NAME_REQUIRED';
  }

  if (!formValues[campaignsConstants.fields.invite_link]) {
    errors[campaignsConstants.fields.invite_link] = 'CAMPAIGNS.SOURCE_REQUIRED';
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/app/main/campaigns/validators/create-campaign-validators.js